var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  fillRule: "evenodd",
  d: "M22 2h-6c-1.6 0-3.1.8-4 2-.9-1.2-2.4-2-4-2H2c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h7c1.1 0 2 .9 2 2 0 .6.4 1 1 1s1-.4 1-1c0-1.1.9-2 2-2h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1M11 17.5c-.6-.3-1.3-.5-2-.5H3V4h5c1.7 0 3 1.3 3 3zm4-.5h6V4h-5c-1.7 0-3 1.3-3 3v10.5c.6-.3 1.3-.5 2-.5",
  clipRule: "evenodd"
})));
export default SvgBook;